import React from 'react';
import style from './tabs.module.scss';
import cx from 'classnames';
import SimpleBar from 'simplebar-react';
import TabItem from './tab-item';

type Props = {
  children: any;
  className?: string;
};
export const Tabs = (props: Props) => {
  const { children, className } = props;

  const classNames = cx(style.tabsContainer, className);

  return (
    <SimpleBar className={classNames}>
      <div className={style.tabs}>{children}</div>
    </SimpleBar>
  );
};

export default Tabs;

Tabs.Item = TabItem;
